import { Grid, Drawer } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import useStyles from '../Styles';
import MenuIcon from '@material-ui/icons/Menu';
import RightDrawer from './RightDrawer';
import LeftDrawer from './LeftDrawer';
import FilterIcon from '../../../assets/filter.png';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';
import ToolbarButtons from './ToolbarButtons';
import { useSelector } from 'react-redux';
import { useLocation } from "react-router";
import userActions from 'components/TechnicalView/actions';


const Visuals = () => {
    const classes = useStyles();
    const [isMenuDrawerOpen, setMenuDrawerOpen] = useState(false);
    const [isFilterDrawerOpen, setFilterDrawerOpen] = useState(false);
    const { isMobile } = useGetViewPortDimensions();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const dropdown = params.get('dropdown');
    const { cities, tribes, western_arizona_entities } = useSelector(
      (state) => state.technical_view
    );
    const {
      setSelectedCity,
      setSelectedTribe,
      setIsCity,
      setIsTribe,
      setIsWesternEntity,
      setSelectedWesternArizonaEntity,
    } = userActions();

    useEffect(() => {
      let concatenatedEntities = [...cities, ...tribes, ...western_arizona_entities]
      var entityFound = concatenatedEntities.find((item) => item?.label?.toLowerCase() === (dropdown?.toLowerCase()));
      if(entityFound) {
        if(entityFound?.entity_type === 'Central') {
          setSelectedCity(entityFound)
          setIsTribe(false);
          setIsCity(true)
          setIsWesternEntity(false);
        } else if (entityFound?.entity_type === 'Tribe') {
          setSelectedTribe(entityFound);
          setIsTribe(true);
          setIsCity(false)
          setIsWesternEntity(false);
        } else {
          setSelectedWesternArizonaEntity(entityFound);
          setIsTribe(false);
          setIsCity(false)
          setIsWesternEntity(true);
        }
      }
    }, [dropdown, cities, tribes, western_arizona_entities])
  

    return (
        <Grid
          container
          justify='space-between'
          alignItems='center'
          className={classes.visualContainer}
          style={{ width: '100vw', zIndex: 20 }}
        >
          {
            isMobile  && (
              <>
              <Grid item onClick={() => {
                setMenuDrawerOpen(!isMenuDrawerOpen)
                setFilterDrawerOpen(false)
              }}>
                <MenuIcon className={classes.menuIcon} style={{ height: 40, width: 40 }} />
              </Grid>
              <ToolbarButtons />
              <Grid item onClick={() => {
                setFilterDrawerOpen(!isFilterDrawerOpen)
              }}>
                <img
                  src={FilterIcon}
                  className={classes.menuIcon}
                  width="27px"
                  height="27px"
                  alt="menu-icon.png"
                />
              </Grid>
              <Drawer
                anchor='left'
                open={isMenuDrawerOpen}
                onClose={() => setMenuDrawerOpen(false)}
                style={{ zIndex: 1 }}
              >
                <LeftDrawer onClose={() => setMenuDrawerOpen(false)}/> 
              </Drawer>
              <Drawer
                ModalProps={{
                  keepMounted: true,
                }}
                anchor='right'
                open={isFilterDrawerOpen}
                onClose={() => setFilterDrawerOpen(false)}
                style={{ zIndex: 1 }}
              >
                <RightDrawer onClose={() => setFilterDrawerOpen(false)} />
              </Drawer>
              </>
            )
          }          
        </Grid>
    )
}

export default Visuals;
